import { render, staticRenderFns } from "./VaIconMenu.vue?vue&type=template&id=4432aece&"
import script from "./VaIconMenu.vue?vue&type=script&lang=js&"
export * from "./VaIconMenu.vue?vue&type=script&lang=js&"
import style0 from "./VaIconMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports